import React, { useEffect, useState } from 'react'
import KonfhubContainer from '../../../revampComponents/Atom/Container'
import { categoryEntity, handleError, mapEntities, TOGGLEMODE } from '../TaskManagement/TaskManagementConstant'
import { getCategoryEntity } from '../../../revampCRUD/categoryEntity.curd'
import { getEventEntity } from '../../../revampCRUD/EventEntity.curd'
import { CHAR_LIMITS, entityModule } from '../../EventInfo/config/constants'
import RichTextEditor from '../../../revampComponents/TipTapEditorNew/components/RichTextEditor'
import UploadFiles from '../TaskManagement/UploadFiles'
import TwoLabelSwitch from '../../../revampComponents/Atom/TwoLabelSwitch'
import TagsComponent from '../../../revampComponents/Atom/Tags/TagsComponent'
import Checkbox from '../../../revampComponents/Atom/Input/Checkbox'
import FormButtons from '../../../revampComponents/Molecule/Buttons/FormButtons'
import { scrollToError } from '../../../Utils/helpers'
import LoadingSpinner from '../../../revampComponents/Atom/Loading'
import { useHistory, useParams } from "react-router-dom"
import DropdownWithIcon from '../TaskManagement/DropdownWithIcon'
import { DeleteModal } from '../../../revampComponents/Atom/Modals'
import { dashboardColors, theme } from '../../../themes/Theme'
import { uploadFile } from '../../../revampCRUD/uploads.crud'
import { ErrMessages, SUCCESS_MESSAGES } from '../../EventInfo/config/error-constants'
import customToast from '../../../components/common/basic/Toast'
import { JS_TYPES } from '../../../reusable/common'
import { ASSET_TYPE_MAPPING, ASSET_TYPE_REVERSE_MAPPING } from './AssetLibraryConstant'


const AddNEditAsset = ({
    formik = {},
    isEdit = false,
    assetTypes = {},
    eventInfo = {},
    loading = false,
    isExhibitorToggle = true,
    onShareTypeToggle = () => { },
    setIsExhibitorToggle,
    setLoading,
    assetDetails
}) => {
    const history = useHistory()
    const { eventId, exhibitorId } = useParams()
    const [isChecked, setIsChecked] = useState([]);
    const [filterTags, setFilterTags] = useState([])
    const [exhibitorData, setExhibitorData] = useState([])
    const [categoryData, setCategoryData] = useState([])
    const [toggleState, setToggleState] = useState({
        toggleMode: isExhibitorToggle ? TOGGLEMODE?.EXHIBITOR : TOGGLEMODE?.CATEGORY
    })
    const [tagsData, setTagsData] = useState([])
    const [value, setValue] = useState("")
    const [openSelectTicketDropdown, setOpenSelectTicketDropdown] = useState(false)
    const [assetTypeChangeModal, setAssetTypeChangeModal] = useState(false)
    const [pendingAssetType, setPendingAssetType] = useState(null)
    const [exhibitorTags, setExhibitorTags] = useState([])
    const [exhibitorChecked, setExhibitorChecked] = useState([])
    const [categoryTags, setCategoryTags] = useState([])
    const [categoryChecked, setCategoryChecked] = useState([])
    const [fileUploadLoading, setFileUploadLoading] = useState(false)

    const assetTypeOptions = Object.entries(assetTypes)?.map(([key, value]) => ({
        value: value,
        label: value,
    }))

    const openDropDown = () => {
        setOpenSelectTicketDropdown(true)
    }

    const eventEntityFunction = async (id) => {
        try {
            const result = await getEventEntity(id, entityModule?.EXHIBITOR)
            if (result) {
                const allEntities = mapEntities(result?.data?.categorized, result?.data?.uncategorized)
                setExhibitorData(allEntities)
                setFilterTags(toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR ? allEntities : categoryData)
            }
        } catch (err) {
            handleError(err)
        }
    }

    const eventCategoryFunction = async (id) => {
        try {
            const result = await getCategoryEntity(id, categoryEntity?.EXHIBITOR)
            if (result) {
                setCategoryData(result?.data)
                if (toggleState?.toggleMode === TOGGLEMODE?.CATEGORY) {
                    setFilterTags(result?.data)
                }
            }
        } catch (err) {
            handleError(err)
        }
    }

    useEffect(() => {
        if (eventInfo?.event_id) {
            eventEntityFunction(eventInfo?.event_id)
            eventCategoryFunction(eventInfo?.event_id)
        }
    }, [eventInfo?.event_id])

    const updateContent = (content) => {
        formik.setFieldValue('description', content)
    }
    const updateAssigneeToggle = (field, value) => {
        const newToggleState = { ...toggleState, [field]: value }
        setToggleState(newToggleState)

        formik.setFieldValue('exhibitor_ids', [])
        formik.setFieldValue('category_ids', [])

        if (value === TOGGLEMODE?.CATEGORY) {
            setExhibitorTags(tagsData)
            setExhibitorChecked(isChecked)
            setTagsData(categoryTags)
            setIsChecked(categoryChecked)
            setFilterTags(categoryData)
        } else {
            setCategoryTags(tagsData)
            setCategoryChecked(isChecked)
            setTagsData(exhibitorTags)
            setIsChecked(exhibitorChecked)
            setFilterTags(exhibitorData)
        }

        onShareTypeToggle(value === TOGGLEMODE?.EXHIBITOR)
    }

    const handleChange = (e) => {
        const searchValue = e?.target?.value?.toLowerCase()
        setValue(e?.target?.value)

        const filteredTags = (toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR
            ? exhibitorData
            : categoryData
        ).filter((tag) =>
            (tag?.category_name || tag?.name || tag?.label || tag?.title)?.toLowerCase()?.includes(searchValue)
        )
        setFilterTags(filteredTags)
        setOpenSelectTicketDropdown(true)
    }

    const deleteClickHandler = (e, filterTag) => {
        const updatedTags = tagsData?.filter((tag) => tag?.id !== filterTag?.id)
        setTagsData(updatedTags)
        setIsChecked((prev) => prev?.filter((id) => id !== filterTag?.id))

        const fieldName = toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR ? 'exhibitor_ids' : 'category_ids'
        const updatedIds = updatedTags?.map(tag => tag?.id || tag?.value)
        formik.setFieldValue(fieldName, updatedIds)
    }

    const toggleSelectAll = () => {
        const isAllSelected = isChecked?.includes("all")

        if (isAllSelected) {
            setIsChecked([])
            setTagsData([])
        } else {
            const sel = filterTags?.map((tag) => tag?.id || tag?.category_id)
            const sel2 = filterTags?.map((tag) => ({
                id: tag?.id || tag?.category_id,
                name: tag?.name || tag?.category_name,
            }))
            setIsChecked([...sel, "all"])
            setTagsData(sel2)
        }
    }

    const onValueSelect = (e, val) => {
        if (val.id === "all") {
            toggleSelectAll()
            return
        }

        const isAlreadySelected = isChecked?.includes(val?.id)

        if (isAlreadySelected) {
            if (isChecked?.includes("all")) {
                const updatedChecked = isChecked?.filter((id) => id !== val?.id && id !== "all")
                setIsChecked(updatedChecked)
                setTagsData(tagsData?.filter((tag) => tag?.id !== val?.id))
            } else {
                const updatedChecked = isChecked?.filter((id) => id !== val?.id)
                setIsChecked([...updatedChecked])
                setTagsData([...tagsData?.filter((tag) => tag?.id !== val?.id)])
            }
        } else {
            if (isChecked?.length > 0 && isChecked?.length === filterTags?.length - 1) {
                setIsChecked([...isChecked, "all", val?.id])
                setTagsData([...tagsData, val])
            } else {
                setIsChecked([...isChecked, val?.id])
                setTagsData([...tagsData, val])
            }
        }
    }

    const enhancedFilterTags = [
        ...(filterTags?.length > 0 && filterTags?.find((tag) => tag?.id !== "all") ? [{ id: "all", name: "All" }] : []),
        ...filterTags?.map((tag) => ({
            id: tag?.id || tag?.category_id,
            name: tag?.name || tag?.category_name,
        }))
    ]

    const getUploadedFiles = async (files) => {
        setFileUploadLoading(true)
        try {
            if (files && files?.length > 0) {
                const needsUpload = files?.some(file => typeof file !== JS_TYPES?.OBJECT || !file?.url);

                const uploadedFiles = await Promise.all(
                    files?.map(async (file) => {
                        if (file && typeof file === JS_TYPES?.OBJECT && file?.url) {
                            return file;
                        } else {
                            const uploadedUrl = await uploadFile(file, 20);
                            return { file_name: file?.name, url: uploadedUrl, file_type: file?.type, file_size: file?.size };
                        }
                    })
                );

                 setFileUploadLoading(false);
                formik.setFieldValue("files", [...uploadedFiles]);

                if (needsUpload) {
                    customToast.success(SUCCESS_MESSAGES?.FILE_MESSAGE);
                }
            }
        } catch (error) {
            customToast.error(ErrMessages?.DEFAULT_ERROR_MESSAGE, error);
        }
    };

    const handleAssetTypeChange = (selectedOption) => {

        const newAssetType = selectedOption?.value
        const currentAssetType = formik?.values?.task_type

        const shouldShowModal =
            newAssetType !== currentAssetType &&
            formik?.values?.files &&
            formik?.values?.files?.length > 0 &&
            (
                (isEdit && requiresFileUpload(currentAssetType)) ||
                (!requiresFileUpload(newAssetType) && requiresFileUpload(currentAssetType))
            )

        if (shouldShowModal) {
            setPendingAssetType(selectedOption)
            setAssetTypeChangeModal(true)
        } else {
            applyAssetTypeChange(selectedOption)
        }
    }


    const applyAssetTypeChange = (selectedOption) => {
        const assetType = selectedOption?.value || '';
        const mappedType = ASSET_TYPE_MAPPING[assetType] || 2;

        formik.setFieldValue('task_type', mappedType);

        if (!requiresFileUpload(assetType)) {
            formik.setFieldValue('files', []);
        }
    };

    const handleDropdownChange = (fieldName, selectedOption) => {
        if (fieldName === 'task_type') {
            handleAssetTypeChange(selectedOption)
        } else {
            formik.setFieldValue(fieldName, selectedOption?.value || '')
        }
    }

    const handleAssetTypeChangeConfirmation = () => {
        if (pendingAssetType) {
            applyAssetTypeChange(pendingAssetType)
            formik.setFieldValue('files', [])
        }

        setAssetTypeChangeModal(false)
        setPendingAssetType(null)
    }

    const handleAssetTypeChangeCancel = () => {
        setAssetTypeChangeModal(false)
        setPendingAssetType(null)
    }

    const handleAutoAssignChange = (e) => {
        const isChecked = e?.target?.checked;

        if (isChecked) {
            const autoAssignType = toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR ? 1 : 2;
            formik.setFieldValue("auto_assign_type", autoAssignType);
        } else {
            formik.setFieldValue("auto_assign_type", null);  // Set to null when unchecked
        }
    };

    useEffect(() => {
        const selectedIds = tagsData
            ?.filter((item) => item?.id !== 'all')
            ?.map((item) => `${item?.id}`);
        if (toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR) {
            formik.setFieldValue("exhibitor_ids", selectedIds);
            setIsExhibitorToggle(true);
        } else if (toggleState?.toggleMode === TOGGLEMODE?.CATEGORY) {
            formik.setFieldValue("category_ids", selectedIds);
            setIsExhibitorToggle(false);
        }
    },
        [tagsData, isEdit, toggleState?.toggleMode]);
    
    const getOptionLabel = (option) => option?.label || option?.name || ''

    const requiresFileUpload = (assetType) => {
        const type =
            typeof assetType === "number"
                ? ASSET_TYPE_REVERSE_MAPPING[assetType]
                : assetType;

        return !["Link (URL)", "Text"].includes(type);
    };

    useEffect(() => {
        if (assetDetails?.category_ids?.length > 0) {
            setToggleState({ toggleMode: TOGGLEMODE.CATEGORY });
            setTagsData(categoryTags);
            setIsChecked(categoryChecked);
            setFilterTags(categoryData);
        } else {
            setToggleState({ toggleMode: TOGGLEMODE?.EXHIBITOR });
            setTagsData(exhibitorTags);
            setIsChecked(exhibitorChecked);
            setFilterTags(exhibitorData);
        }
    }, [assetDetails?.category_ids, exhibitorData, categoryData]);


    useEffect(() => {
        if (!isEdit) return;

        const transformCategoryData = (data, categoryIds) =>
            data
                ?.filter(item => categoryIds?.includes(String(item?.category_id)))
                ?.map(({ category_id: id, category_name: name }) => ({ id, name }));

        const getAllIds = (data) => data?.map(({ id }) => id);
        const getIdAndName = (data) => data?.map(({ id, entity_name: name }) => ({ id, name }));

        const editExhibitorData = formik?.values?.exhibitors || [];
        const category = transformCategoryData(categoryData, assetDetails?.category_ids);

        if (toggleState.toggleMode === TOGGLEMODE.EXHIBITOR) {
            setFilterTags(exhibitorData);
            if (exhibitorData.length === editExhibitorData?.length) {
                setIsChecked([...getAllIds(editExhibitorData), 'all']);
                setTagsData(getIdAndName(editExhibitorData));
            } else {
                setIsChecked(getAllIds(editExhibitorData));
                setTagsData(getIdAndName(editExhibitorData));
            }
        } else {
            setFilterTags(categoryData);
            if (category?.length === categoryData?.length) {
                setIsChecked([...getAllIds(category), 'all']);
                setTagsData(category);
            } else {
                setIsChecked(getAllIds(category));
                setTagsData(category);
            }
        }
    }, [isEdit, exhibitorData, categoryData, assetDetails.category_ids, toggleState.toggleMode]);


    return (
        <div>
            <KonfhubContainer>
                <>
                    {formik?.values && Object?.keys(formik?.values)?.length !== 0 ? (
                        <div className="">
                            <form onSubmit={formik?.handleSubmit}>
                                <div className="row">
                                    <div className="col-12 col-md-12 pt-1">
                                        <div>
                                            <label htmlFor="title" className="label  mt-2">
                                                Asset Title <span className="text-danger"> *</span>
                                            </label>
                                        </div>
                                        <div>
                                            <input
                                                id="title"
                                                name="title"
                                                placeholder="Enter asset title"
                                                type="text"
                                                onChange={formik?.handleChange}
                                                onBlur={formik?.handleBlur}
                                                value={formik?.values?.title}
                                                className={
                                                    formik?.errors?.title && formik?.touched.title
                                                        ? "input border-danger box-shawdow-none"
                                                        : "input task-input-label"
                                                }
                                            />
                                            {formik?.errors?.title && formik?.touched?.title && (
                                                <p className="text-danger mt-2">{formik?.errors?.title}</p>
                                            )}
                                        </div>
                                    </div>


                                    <div className="col-12 col-md-12 pt-1 mt-2">
                                        <div>
                                            <label htmlFor="description" className="label mt-2">
                                                Asset Description
                                            </label>
                                        </div>
                                        <div>
                                            <RichTextEditor
                                                content={formik?.values?.description || ''}
                                                onChangeContent={updateContent}
                                                placeholder="Enter your asset description here"
                                                showTextFormatters
                                                showTextHighlighters
                                                showHistory
                                                showTextAligners
                                                showLists
                                                showTable
                                                showImage
                                                showVideo
                                                showBlockQuote
                                                showHr
                                                showLink
                                                showSlashCommand
                                            />
                                            <div className="d-flex justify-content-between">
                                                <p className="text-danger mt-2 pt-1 mb-0">
                                                    {formik?.errors?.description &&
                                                        formik?.touched?.description && (
                                                            <p>{formik?.errors?.description}</p>
                                                        )}
                                                </p>
                                                <p className="maxCharForInput">
                                                    Maximum Characters: {CHAR_LIMITS?.taskDescription?.descMax || 500}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 pt-1 mt-2">
                                        <div>
                                            <label htmlFor="task_type" className="label mt-2">
                                                Asset Type <span className="text-danger"> *</span>
                                            </label>
                                        </div>
                                        <div>
                                            <DropdownWithIcon
                                                value={assetTypeOptions?.find(
                                                    (option) => option?.value === formik?.values?.task_type,
                                                )}
                                                options={assetTypeOptions}
                                                onChange={(option) =>
                                                    handleDropdownChange("task_type", option)
                                                }
                                                onBlur={() => formik.setFieldTouched("task_type", true)}
                                                getOptionLabel={getOptionLabel}
                                                disabled={isEdit}
                                                className={`task-dropdown ${isEdit ? "task-dropdown-disabled" : ""}`}
                                            />
                                            {formik?.errors?.task_type && formik?.touched?.task_type && (
                                                <p className="text-danger mt-2">{formik?.errors?.task_type}</p>
                                            )}
                                        </div>
                                    </div>
                                    {formik?.values?.task_type === ASSET_TYPE_MAPPING['Link (URL)'] && (
                                        <div className="col-12 col-md-12 pt-1 mt-2">
                                            <div>
                                                <label htmlFor="asset_link" className="label mt-2">
                                                    Link <span className="text-danger"> *</span>
                                                </label>
                                            </div>
                                            <div>
                                                <input
                                                    id="asset_link"
                                                    name="asset_link"
                                                    placeholder="https://example.com"
                                                    type="url"
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    value={formik?.values?.asset_link || ''}
                                                    className={
                                                        formik?.errors?.asset_link && formik?.touched?.asset_link
                                                            ? "input border-danger box-shawdow-none"
                                                            : "input task-input-label"
                                                    }
                                                />
                                                {formik?.errors?.asset_link && formik?.touched?.asset_link && (
                                                    <p className="text-danger mt-2">{formik?.errors?.asset_link}</p>
                                                )}
                                            </div>
                                        </div>
                                    )}


                                    {requiresFileUpload(formik?.values?.task_type) && (
                                        <UploadFiles
                                            isEdit={isEdit}
                                            formik={formik}
                                            getUploadedFiles={getUploadedFiles}
                                            loading={fileUploadLoading}
                                            isAssetScreen={true}
                                        />
                                    )}

                                    <div className="col-12 col-md-12 pt-1 mt-2">
                                        <div className="d-flex align-items-center">
                                            <span className="label manual-label-text asset-library-form-checkbox-title">
                                                Share with Exhibitors
                                            </span>
                                            <div className="mx-3">
                                                <TwoLabelSwitch
                                                    value={toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR}
                                                    onChangeSwitch={(value) => {
                                                        const newMode = value
                                                            ? TOGGLEMODE?.CATEGORY
                                                            : TOGGLEMODE?.EXHIBITOR
                                                        updateAssigneeToggle("toggleMode", newMode)
                                                    }}
                                                />
                                            </div>
                                            <span className="label asset-library-form-checkbox-title">Share with Categories</span>
                                        </div>
                                        <TagsComponent
                                            addMultipleTagsButton={false}
                                            placeholder={toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR
                                                ? "Search by typing an exhibitor name"
                                                : "Search by typing a category name"
                                            }
                                            noDataText={
                                                toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR
                                                    ? (tagsData?.length === 0 || filterTags?.length === 0
                                                        ? "No Exhibitors found"
                                                        : "")
                                                    : (categoryData?.length === 0
                                                        ? "No Categories found"
                                                        : "")
                                            }
                                            tagsData={tagsData}
                                            dragEnd={null}
                                            editIcon={false}
                                            deleteIcon={true}
                                            deleteClickHandler={deleteClickHandler}
                                            isDragDisabled={true}
                                            value={value}
                                            handleChange={handleChange}
                                            CheckboxDropdownData={enhancedFilterTags}
                                            onValueSelect={onValueSelect}
                                            openSelectTicketDropdown={openSelectTicketDropdown}
                                            setOpenSelectTicketDropdown={setOpenSelectTicketDropdown}
                                            isChecked={isChecked}
                                            setValue={setValue}
                                            setTagsData={setFilterTags}
                                            addNewValueinDropDown={false}
                                            openDropDown={openDropDown}
                                            isSelectInclude={true}
                                            showNoDataMessage={false}
                                        />
                                        <div>
                                            {toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR && formik.errors.exhibitor_ids && formik?.touched?.exhibitor_ids && (
                                                <p className="text-danger mt-2">{formik?.errors?.exhibitor_ids}</p>
                                            )}
                                            {toggleState?.toggleMode === TOGGLEMODE?.CATEGORY && formik?.errors?.category_ids && formik?.touched?.category_ids && (
                                                <p className="text-danger mt-2">{formik?.errors?.category_ids}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-between mt-4">
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex justify-content-center aligns-items-center">
                                            <Checkbox
                                                labelClassName="checkboxCard-label ml-1"
                                                checked={formik?.values?.auto_assign_type === (toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR ? 1 : 2)}
                                                onChange={handleAutoAssignChange}  
                                            />

                                            <span className="label asset-library-form-input-title pr-2">
                                                {`Auto Share with Future ${toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR
                                                    ? "Exhibitors"
                                                    : "Exhibitors of the Selected Categories"
                                                    }`}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-2 loadingCenter">
                                    <FormButtons
                                        isLoading={loading || formik.isSubmitting}
                                        formik={formik}
                                        onSave={() => {
                                            scrollToError(formik)
                                            formik.submitForm()
                                        }}
                                        onCancel={() => {
                                            formik.handleReset()
                                            history.push(
                                                `/e/${eventId}/exhibitor-portal/asset-library`)
                                        }}
                                        saveBtnContent={isEdit ? "Save" : "Add"}
                                        saveBtnDisabled={loading || !formik.dirty || formik.isSubmitting || fileUploadLoading }
                                    />
                                </div>
                            </form>
                            <DeleteModal
                                width={"420px"}
                                openModal={assetTypeChangeModal}
                                setOpenModal={setAssetTypeChangeModal}
                                primaryBtnContent={"Yes"}
                                cancelBtnContent={"No"}
                                item=""
                                extraComponent={
                                    <p className="mt-4 uploaded-images change-asset-type-cont">
                                        <b>Note: </b>
                                        <span className="change-asset-noteText">
                                            Changing the asset type will delete all the files you've already uploaded.
                                        </span>
                                    </p>
                                }
                                text={`  <b>Change Asset Type </b>  <br /> Do you want to change the asset type?`}
                                onCancel={handleAssetTypeChangeCancel}
                                onOkay={handleAssetTypeChangeConfirmation}
                            />
                        </div>
                    ) : (
                        <LoadingSpinner />
                    )}
                    <style>{`
                        .task-upload-container {
                            width: 100%;
                        }
                        .asset-library-form-input-title{
                             color: ${dashboardColors[theme].primaryTextColor} !important;
                            margin-bottom: 5px;
                        }
                        .asset-library-form-checkbox-title{
                            color: ${dashboardColors[theme].primaryTextColor} !important;
                        }
                        .asset-library-form-input-subtitle{
                            color:#333333;
                            font-size:14px;
                            font-weight:400;
                        }
                        .checkboxCard-label{
                            margin-top:5px;
                        }

                        .change-asset-type-cont {
                            background-color: #f8f8f8;
                            padding: 10px;
                            color: #6c757d;
                            border-radius: 5px;
                            border: 1px solid #e2e2e2;
                            font-size: 15px;
                            line-height: 24px;
                        }
            
                        .task-dropdown-disabled {
                            opacity: 0.6;
                            pointer-events: none;
                        }
                        .change-asset-type-cont b{
                            color:${dashboardColors[theme].primaryTextColor} !important;
                        }
                        .change-asset-noteText{
                            font-size:14px;
                            font-weight:400;
                            color:${dashboardColors[theme].primaryTextColor} !important;
                        }
                    `}</style>
                </>
            </KonfhubContainer>
        </div>
    )
}

export default AddNEditAsset
